export default {
  setMails(state, data) {
    state.mails = data;
  },

  sentMails(state, data) {
    state.sentMails = data;
  },
};
